const sendEvent = (eventName, parameters = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;

  window.gtag('event', eventName, parameters);
};

export const trackEvent = (eventName, parameters) => {
  sendEvent(eventName, parameters);
};

export const trackSessionEvent = (eventName, storageKey, parameters) => {
  if (typeof window === 'undefined') return;

  try {
    if (window.sessionStorage.getItem(storageKey)) return;
    window.sessionStorage.setItem(storageKey, 'true');
  } catch (_) {
    // Storage can be unavailable in privacy modes. The caller's in-memory guard
    // still prevents duplicate events during the mounted form session.
  }

  sendEvent(eventName, parameters);
};

const linkLocation = (link) => {
  if (link.closest('header')) return 'header';
  if (link.closest('footer')) return 'footer';
  if (window.location.pathname === '/contact') return 'contact_page';
  if (window.location.pathname === '/apply') return 'application_page';
  return 'program_page';
};

const houseTypeForPhone = (href) => {
  if (href.includes('570-579-7695')) return 'mens';
  if (href.includes('610-443-0175')) return 'womens';
  return undefined;
};

// A single delegated listener covers current and future CTA/contact links without
// adding competing handlers or changing navigation behavior.
export const handleAnalyticsLinkClick = (event) => {
  const link = event.target.closest?.('a[href]');
  if (!link) return;

  const href = link.getAttribute('href') || '';
  if (href.startsWith('tel:')) {
    const houseType = houseTypeForPhone(href);
    trackEvent('phone_click', {
      ...(houseType ? { house_type: houseType } : {}),
      phone_location: linkLocation(link),
    });
    return;
  }

  if (href.startsWith('mailto:')) {
    trackEvent('email_click');
    return;
  }

  try {
    const url = new URL(link.href, window.location.origin);
    if (url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === '/apply') {
      trackEvent('apply_click');
    }
  } catch (_) {
    // Ignore malformed/non-navigation hrefs.
  }
};
